module Meevo.Plugins.Client {
    "use strict";
    /**
    * FamilySection Section -- need aggregate model for handling functionality.
    */
    export class FamilySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<any> {
        clientToAdd: any;
        public canBreakFamily: boolean = false;
        public isNotHeadOfHousehold: boolean = false;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            canBreakFamily: boolean,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            noun: Meevo.Model.NounEnum = null,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            sectionSecurityKey?:string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService,noun,appSettings,sectionSecurityKey);
            this.noun = noun;
            this.canBreakFamily = canBreakFamily;
        }

        usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum): void {
          let trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, this.parentItemId);
          this.trackingService.saveTrackingInfo(trackingItem);
        }

        startFamily(): void {
            this.model.familyMembers.push({
                id: this.model.id,
                firstName: this.model.firstName,
                lastName: this.model.lastName,
                isMinor: this.model.isMinor,
                isHeadOfHousehold: true
            });

            this.model.canStartFamily = false;
            this.model.familyExists = true;
            this.model.headOfHouseholdId = this.model.id;
            this.model.isHeadOfHousehold = true;
            this.usageTrackingLog(Meevo.Model.NounEnum.ClientFamily, Meevo.Model.VerbEnum.StartFamilyClicked);
        }

        breakFamily(): void {
            this.model.familyMembers = [];
            this.model.familyExists = false;
            this.model.canStartFamily = true;
            this.isNotHeadOfHousehold = false;
            this.usageTrackingLog(Meevo.Model.NounEnum.ClientFamily, Meevo.Model.VerbEnum.BreakFamilyClicked);
        }

        takeOwnership(): void {
            this.model.headOfHouseholdId = this.model.id;
            _.forEach(this.model.familyMembers, (o: any) => {
                if (o.id !== this.model.id) {
                    o.isHeadOfHousehold = false;
                } else {
                    o.isHeadOfHousehold = true;
                }
            });
        }

        addFamilyMember(): void {
            if (_.findWhere(this.model.familyMembers, { id: this.clientToAdd.id }) === undefined) {

                let familyMember = {
                    id: this.clientToAdd.id,
                    displayName: this.clientToAdd.displayName,
                    middleName: this.clientToAdd.middleName,
                    firstName: this.clientToAdd.firstName,
                    lastName: this.clientToAdd.lastName,
                    isHeadOfHousehold: false
                }

                if (this.model.familyMembers.length == 0) {
                    let headMember = {
                        id: this.model.id,
                        displayName: this.model.displayName,
                        middleName: this.model.middleName,
                        firstName: this.model.firstName,
                        lastName: this.model.lastName,
                        isMinor: false,
                        isHeadOfHousehold: true
                    }
                    this.model.familyMembers.push(headMember);
                }

                this.model.familyMembers.push(familyMember);
                this.model.familyExists = true;
                this.model.isHeadOfHousehold = true;

                this.usageTrackingLog(Meevo.Model.NounEnum.ClientFamily, Meevo.Model.VerbEnum.AddMemberClicked);
            }

            this.clientToAdd = null;
        }

        removeFamilyMember(familyMember:any): void {
            let index = this.model.familyMembers.indexOf(familyMember);
            if (index > -1) {
              this.model.familyMembers.splice(index, 1);
              this.usageTrackingLog(Meevo.Model.NounEnum.ClientFamily, Meevo.Model.VerbEnum.DeleteButtonClicked);
                if (this.model.familyMembers.length === 0) {
                    this.model.familyExists = false;
                    this.model.canStartFamily = true;
                }
            }
        }

        showRemoveOption(familyMember: any) {
            // Allow users to remove themselves from the family
            // Allow Head of Household to remove other members (except for themselves)
            return (!familyMember.isHeadOfHousehold && !familyMember.isMinor && familyMember.id == this.model.id) ||
                (!familyMember.isHeadOfHousehold && this.model.isHeadOfHousehold)
        }

        headOfHouseholdInfo(): any {
            let headofHousehold:any = _.findWhere(this.model.familyMembers, { isHeadOfHousehold: true });
            if (headofHousehold != undefined)
                return headofHousehold.displayName;
            else
                return "";
        }

        addPotentialFamilyMember(): void {
            if (_.findWhere(this.model.familyMembers, { id: this.clientToAdd.id }) === undefined) {
                // check for other client's family settings
                this.dataService.customMethodData(`api/Client/${this.clientToAdd.id}/Family`, "GET", {})
                    .then((response) => {
                        let familyOfClientToAdd: any = response.data;
                        if (familyOfClientToAdd && familyOfClientToAdd.familyExists) {
                            if (this.model.familyExists) {
                                // NOTE: need to ask Tanya thio scenario

                                this.clientToAdd = null;
                            }
                            else {
                                let msg = this.$translate.instant("LABEL_CLIENT_ADD_CLIENT_TO_FAMILY", {
                                    searchedClientDisplayName: familyOfClientToAdd.displayName,
                                    currentClientDisplayName: this.model.displayName
                                });
                                this.modalService.confirm(msg)
                                    .then((isConfirmed) => {
                                        // add this client to that client's family
                                        let familyMember = {
                                            id: this.model.id,
                                            displayName: this.model.displayName,
                                            middleName: this.model.middleName,
                                            firstName: this.model.firstName,
                                            lastName: this.model.lastName,
                                            isHeadOfHousehold: false,
                                            isMinor: this.model.isMinor
                                        }

                                        familyOfClientToAdd.familyMembers.push(familyMember);
                                        familyOfClientToAdd.id = this.model.id;
                                        familyOfClientToAdd.displayName = this.model.displayName;
                                        familyOfClientToAdd.middleName = this.model.middleName;
                                        familyOfClientToAdd.firstName = this.model.firstName;
                                        familyOfClientToAdd.lastName = this.model.lastName;
                                        familyOfClientToAdd.isMinor = this.model.isMinor;
                                        familyOfClientToAdd.canTakeOwnership = false; //!this.model.isMinor;
                                        familyOfClientToAdd.isHeadOfHousehold = false;

                                        this.model = familyOfClientToAdd;
                                        this.isNotHeadOfHousehold = true;

                                        //NOTE: this is probably wrong since we're adding this client to another family
                                        this.usageTrackingLog(Meevo.Model.NounEnum.ClientFamily, Meevo.Model.VerbEnum.AddMemberClicked);
                                    })
                                    .finally(() => {
                                        this.clientToAdd = null;
                                    });
                            }
                        }
                        else {
                            this.addFamilyMember();
                        }
                    });
            }
        }

        public sectionModelRetrieved(): void {
            this.isNotHeadOfHousehold = (this.model && this.model.id != this.model.headOfHouseholdId && this.model.headOfHouseholdId != null);
        }
    }
}